import { gql } from "lib/apolloClient";
import { attachmentItem } from "Teacher/routes/StudentGoals/components/RightPane/components/AttachmentsWrapper/modules/AttachmentWrapperFragments";

export const goalItem = gql`
  fragment goalItem on StudentGoal {
    id
    title
    targetDate
    goalTasks {
      ...goalTaskItem
    }
    createdAt
    updatedAt
    isComplete
    isRead
    note
    createdBy {
      id
    }
    comments {
      totalCount
      unreadCountV2
    }
    evidences(parentType: STUDENT_GOAL, evidenceType: POST) {
      edges {
        id
        evidenceItem {
          id
          ... on Post {
            ...postItem
          }
        }
      }
    }
  }
`;

export const postItem = gql`
  fragment postItem on Post {
    id
    title
    attachments {
      ...attachmentItem
    }
    createdAt
    publishedAt
    comments {
      totalCount
      unreadCount
    }
    state
  }
  ${attachmentItem}
`;

export const studentGoalTask = gql`
  fragment goalTaskItem on GoalTask {
    id
    title
    note
    checkinDate
    posts {
      ...postItem
    }
    comments {
      totalCount
      unreadCountV2
    }
    isComplete
    displaySequence
  }
  ${postItem}
`;

export const studentGoalFragments = {
  goalFeed: gql`
    fragment studentGoalsItem on Student {
      studentGoalsV2(last: $last, after: $after, filters: $filters) {
        totalCount
        edges {
          cursor
          node {
            ...goalItem
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        count {
          ongoing
          completed
        }
      }
    }
    ${goalItem}
    ${postItem}
    ${studentGoalTask}
  `,
};
